// Login.js
import React, { useState, useContext } from 'react';
import { AuthContext } from '../../helper/util/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../../helper/util/api';

import "./login.css";

export default function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const res = await api.post('/auth/login', { email, password });
      console.log("Login response:", res)
      if (!res.statusText) {
        alert(res.data.message || 'Invalid username or password');
        return;
      }
      login(res.data.token, res.data.user);
      navigate('/');
    } catch (err) { 
      const errorMessage = err.response?.data?.message || err.message || 'Error while login';
      alert(errorMessage);
    }
  }

  return (
    // <div class="login-container">
    //   <h2>Login</h2>
    //   <form onSubmit={handleSubmit}>
    //     <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" required />
    //     <input value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required />
    //     <button type="submit">Login</button>
    //   </form>
    // </div>
    <div className='login-container'>
      <div className="logo-container">
        <div className="logo-header">
          <img className="login-logo" src="/logo512-without-name.png" alt="logo" />
          <span className="logo-title">SRV Realtech India</span>
          <span className="logo-subtitle">Client Management Portal</span>
        </div>
        <div className="footer-container">
          <span className="login-footer">© 2026 SRV Realtech India. All rights reserved.</span>
        </div>
      </div>
      <div className="form-container">
          <div className="login-header">
            <h2 className="login-title">Login</h2>
          </div>

          <form onSubmit={handleSubmit} className="login-form" noValidate>
            <input
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              type="email"
              autoComplete="email"
              required
              aria-label="Email"
            />
            <input
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              type="password"
              autoComplete="current-password"
              required
              aria-label="Password"
            />
            <button type="submit" className="login-button">Login</button>
          </form>
      </div>
    </div>

  );
}
